<template>
  <div class="Ledger">
    <div class="page-title">{{ title }}</div>
    <div>
      <div class="inline" style="width: 300px;">
        <ACustomerSelector size="mini" seller @select="handleSelectCustomer" />
      </div>
      <div class="inline" style="width: 200px;">
        <el-input placeholder="전화번호" :value="cutomer_tel" disabled>
          <template slot="prepend">연락처</template>
        </el-input>
      </div>
      <div class="inline ml-default" style="width: 200px;">
        <el-input placeholder="팩스" :value="cutomer_fax" disabled>
          <template slot="prepend">팩스</template>
        </el-input>
      </div>
      <div class="inline ml-default" style="width: 500px;">
        <el-input placeholder="비고" :value="cutomer_desc" disabled>
          <template slot="prepend">비고</template>
        </el-input>
      </div>
    </div>
    <div class="mt-default">
      <el-tabs type="card" v-model="active_tab" @tab-click="handleTabClick">
        <el-tab-pane label="매출" name="0">
          <SaleLedger
            ref="sale"
            v-if="sale_visible"
            :customer="customer"
            :disabled="!customer"
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
        <el-tab-pane label="수금" name="1">
          <CollectLedger
            ref="collect"
            v-if="collect_visible"
            :customer="customer"
            :disabled="!customer"
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
        <el-tab-pane label="거래" name="2">
          <IncomeLedger
            ref="income"
            v-if="trade_visible"
            :customer="customer"
            :disabled="!customer"
          />
        </el-tab-pane>
        <el-tab-pane label="검색" name="3">
          <SearchLedger
            ref="search"
            v-if="search_visible"
            :customer="customer"
            :disabled="!customer"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { authority_level } from "@/common/mixins/authority_level";
import SaleLedger from "./SaleLedger";
import CollectLedger from "./CollectLedger";
import IncomeLedger from "./IncomeLedger";
import SearchLedger from "./SearchLedger";

export default {
  name: "Ledger",
  mixins: [authority_level],
  components: { SaleLedger, CollectLedger, IncomeLedger, SearchLedger },
  data() {
    return {
      title: this.$t("title.sale_ledger"),
      customer: null,
      active_tab: "0",
      sale_visible: true,
      collect_visible: false,
      trade_visible: false,
      search_visible: false,
    };
  },
  computed: {
    has_grant_write() {
      return this.isWriteLevel("sale_ledger");
    },
    cutomer_tel() {
      return this.customer ? this.customer.tel : "";
    },
    cutomer_fax() {
      return this.customer ? this.customer.fax : "";
    },
    cutomer_desc() {
      return this.customer ? this.customer.desc : "";
    },
  },
  methods: {
    handleSelectCustomer(customer) {
      if (typeof customer !== "object") {
        return;
      }
      this.customer = Object.assign({}, customer);
    },
    handleTabClick(tab) {
      switch (tab.name) {
        case "1":
          this.collect_visible = true;
          this.$nextTick(() => {
            this.$refs.collect.loadData();
          });
          break;
        case "2":
          this.trade_visible = true;
          this.$nextTick(() => {
            this.$refs.income.loadData();
          });
          break;
        case "3":
          this.search_visible = true;
          break;
        default:
          this.$nextTick(() => {
            this.$refs.sale.loadData();
          });
          break;
      }
    },
  },
};
</script>
